import * as jose from "jose";
import {
  ACCESS_TOKEN,
  IS_LOGGED_IN_KEY,
  IS_LOGGED_IN_VALUE,
} from "../config/app";
import Cookies from "js-cookie";
import { IS_CLIENT } from "../config/common";
import { useNavigate } from "react-router-dom";
const useAuth = () => {
  const navigate = useNavigate();
  const hasLoggedInCookie = () => {
    const isLoggedInCookie = Cookies.get(IS_LOGGED_IN_KEY);
    return Boolean(isLoggedInCookie) && isLoggedInCookie === IS_LOGGED_IN_VALUE;
  };
  const isUser = hasLoggedInCookie();

  function getUserData() {
    if (isUser) {
      const token = window.localStorage.getItem(ACCESS_TOKEN)
        ? window.localStorage.getItem(ACCESS_TOKEN)
        : null;
      if (token) {
        const user = jose.decodeJwt(token);
        const role =
          user["https://hasura.io/jwt/claims"]["x-hasura-default-role"];
        if (role === "customer") {
          return user?.user_id;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }

  // async function fetchUserDetail(id) {
  //   try {
  //     const response = await fetch("https://api.axpigeon.axra.app/v1/graphql", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
  //       },
  //       body: JSON.stringify({
  //         query: `query MyQuery($id: uuid!) {
  //       customers_by_pk(id: $id) {
  //         username
  //         id
  //       }
  //     }`,
  //         variables: {
  //           id,
  //         },
  //       }),
  //     });

  //     const result = await response.json();
  //     user = result?.data?.customers_by_pk;
  //     return result?.data?.customers_by_pk;
  //   } catch (error) {
  //     console.error("Error fetching user detail:", error);
  //   }
  // }

  const logout = () => {
    Cookies.remove(IS_LOGGED_IN_KEY);
    IS_CLIENT && window.localStorage.removeItem(ACCESS_TOKEN);
    navigate("/login");
  };
  return {
    userId: isUser ? getUserData() : null,
    logout,
  };
};

export default useAuth;
